// @ts-check
import React from "react"
import InputText from "../atoms/InputText.atom"
import PropTypes from "prop-types"
import ErrorMessageForm from "../atoms/ErrorMessageForm.atom"
import { hasAnyErrors } from "../../utils/validations.utils"
import Label from "../atoms/Label.atom"
import ViewOutputForm from "../atoms/ViewOutputForm.atom"
import { clsx } from "../../utils/strings.utils"

/** @type {import("./InputTextForm.molecule.types").InputTextFormMolecule} */
const InputTextForm = React.forwardRef(
  (
    {
      optional = false,
      require = false,
      disabled = false,
      viewOnly = false,
      autoTrim = true,
      error = [],
      type = "text",
      autoComplete = "off",
      autoFocus,
      onKeyDown,
      keyfilter,
      prefixIcon,
      label,
      iconProps,
      suffixIcon,
      className,
      wrapperClassName,
      value,
      name,
      maxLength,
      onBlur,
      id,
      placeholder = " ", // this &nbsp; is needed for :not(:placeholder-shown) style,
      onChange,
    },
    ref
  ) => {
    const forId =
      id ||
      `form-input-text-${label?.replace(/ /g, "-")}-${new Date().getTime()}`
    return (
      <>
        {label && (
          <Label
            className={disabled ? "p-disabled" : ""}
            id={"form-input-text-label"}
            htmlFor={forId}
          >
            {label}
            {require ? " *" : ""}
            {optional ? " (opcional)" : ""}
          </Label>
        )}{" "}
        {viewOnly ?
          <ViewOutputForm value={value} />
        : <span
            className={clsx(
              prefixIcon && "p-input-icon-left",
              suffixIcon && "p-input-icon-right",
              wrapperClassName
            )}
          >
            {prefixIcon && <i className={"pi " + prefixIcon} {...iconProps} />}
            <InputText
              ref={ref}
              id={forId}
              name={name}
              keyfilter={keyfilter}
              type={type}
              value={value}
              onChange={onChange}
              onBlur={(e) => {
                if (autoTrim) {
                  const trimmedValue = e.target.value.trim()
                  e.target.value = trimmedValue
                  onChange &&
                    onChange({
                      target: { name: name || "", value: trimmedValue },
                    })
                }
                onBlur && onBlur(e)
              }}
              placeholder={placeholder}
              className={clsx(
                hasAnyErrors(error) && "p-invalid",
                "w-full",
                className
              )}
              disabled={disabled}
              maxLength={maxLength}
              autoComplete={autoComplete}
              autoFocus={autoFocus}
              onKeyDown={onKeyDown}
            />
            {suffixIcon && <i className={"pi " + suffixIcon} {...iconProps} />}
          </span>
        }
        {hasAnyErrors(error) ?
          <ErrorMessageForm
            className={clsx("helper-text-" + forId, disabled && " p-disabled")}
            id="form-input-text-helper-text"
            errorMessage={error[0]?.errorMessage}
          />
        : null}
      </>
    )
  }
)

export default InputTextForm

InputTextForm.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.string]),
  type: PropTypes.oneOfType([PropTypes.oneOf(["text", "email", undefined])]),
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  // @ts-ignore
  keyfilter: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.array]),
  require: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.bool]),
  optional: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.bool]),
  autoTrim: PropTypes.bool,
  autoComplete: PropTypes.string,
  prefixIcon: PropTypes.string,
  suffixIcon: PropTypes.string,
}

InputTextForm.defaultProps = {
  autoTrim: true,
}
